import { create } from 'zustand';
import { getDataNetEmails } from '../../features/team/services/userApi';

export const useDataNetStore = create((set, get) => ({
  // { [userId]: boolean } — undefined means not yet fetched from HaloPSA
  dataNetState: {},

  setUserDataNet: (userId, value) =>
    set((state) => ({
      dataNetState: { ...state.dataNetState, [userId]: value },
    })),

  bulkSetDataNet: (entries) =>
    set((state) => ({
      dataNetState: { ...state.dataNetState, ...entries },
    })),

  // Fetches the real value from HaloPSA once per session per user.
  // No-ops if already fetched (value is not undefined).
  initDataNetForUser: async (userId) => {
    if (userId == null) return;
    if (get().dataNetState[userId] !== undefined) return;
    try {
      const response = await getDataNetEmails(userId);
      const value = response?.data?.dataNetEmails ?? true;
      set((state) => ({
        dataNetState: { ...state.dataNetState, [userId]: value },
      }));
    } catch {
      // On error keep undefined so next mount retries
    }
  },
}));
